import React, { Component, Fragment } from "react";
import ReservationForm from "./ReservationForm";
import { history } from "../../_helpers/history";
import { Prompt } from "react-router";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import FadeIn from "react-fade-in";

import "./../style.css";

export default class ReservationPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shouldBlockNavigation: false,
    };
  }

  componentDidUpdate = () => {
    if (this.state.shouldBlockNavigation) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  };

  handleRedirect = () => {
    this.setState({ shouldBlockNavigation: false }, function () {
      history.push("appointment/registered");
    });
  };

  handleShouldBlock = () => {
    if (this.state.shouldBlockNavigation === false) {
      this.setState({ shouldBlockNavigation: true });
    }
  };

  render() {
    return (
      <Fragment>
        <Prompt
          when={this.state.shouldBlockNavigation}
          message="You have unsaved changes, are you sure you want to leave?"
        />
        <Header />
        <FadeIn>
          <ReservationForm
            redirect={this.handleRedirect}
            shouldBlock={this.handleShouldBlock}
          />
        </FadeIn>
        <Footer />
      </Fragment>
    );
  }
}
